import { render, staticRenderFns } from "./legendTag-1.vue?vue&type=template&id=dba1e5b0&scoped=true&"
import script from "./legendTag-1.vue?vue&type=script&lang=js&"
export * from "./legendTag-1.vue?vue&type=script&lang=js&"
import style0 from "./legendTag-1.vue?vue&type=style&index=0&id=dba1e5b0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba1e5b0",
  null
  
)

export default component.exports